$(function () {
  $(".btn-modal-close .button").on("click", function () {
    mtdev.setCookie("sub-popup-hidden", "isSet", 1);
    $(".subscribe-popup").removeClass("shown");
  });

  $("#ContactPopup").submit(function (e) {
    mtdev.setCookie("sub-popup-hidden", "isSubmitted, " + document.location, 1);
  });

  let my_popup_cookie = mtdev.getCookie("sub-popup-hidden") || "";
  console.log("my_popup_cookie", my_popup_cookie);

  let showModal = () => {
    $(".subscribe-popup").addClass("shown");
  };

  let showMessage = () => {
    $("#ContactPopup").hide();
    $("#ContactPopup + p").show();
  };

  if (!document.location.pathname.includes("challenge")) {
    if (my_popup_cookie.includes("isSubmitted")) {
      showModal();
      showMessage();
      mtdev.setCookie("sub-popup-hidden", "isSet", 1);
    }
  } else {
    mtdev.setCookie("sub-popup-hidden", "isSubmitted, " + document.location, 1);
  }

  if (
    !my_popup_cookie.includes("isSet") &&
    !my_popup_cookie.includes("isSubmitted")
  ) {
    setTimeout(() => {
      showModal();
    }, 5000);
  }
});
